import throttle  from 'lodash/throttle';
import { theme } from '@root/tailwind.config.js';

(() => {
	// The hamburger in the bottombar get's toggled in .vue
	const hamburgerMenus = document.querySelectorAll('#hamburger, #sticky-hamburger');
	const mainmenu = document.querySelector('.mainmenu');
	const header = document.querySelector('.header');
	const mobileBreakpoint = Number.parseInt(theme.screens.lg.replace('px', ''));

	if(header && mainmenu) {
		const resizeListener = () => {
			const windowWidth = window.innerWidth;
			if (windowWidth <= mobileBreakpoint) {
				const headerHeight = header.clientHeight;
				mainmenu.style.height = `calc(100% - ${headerHeight}px)`;
				[...hamburgerMenus].forEach(hamburgerMenu => {
					hamburgerMenu.addEventListener('click', openMenuModal);
				});
			} else {
				mainmenu.style.height = null;
			}
		};

		const openMenuModal = throttle(function(e) {
			const windowWidth = window.innerWidth;
			e.preventDefault();
			if (windowWidth <= mobileBreakpoint && mainmenu) {
				window.EventBus.$emit('open-modal', 'menu');
			}
		}, 200);
		
		window.addEventListener('load', resizeListener);
		window.addEventListener('resize', throttle(resizeListener, 200));
	}
})();
